import { render, staticRenderFns } from "./xinXiBianJi.vue?vue&type=template&id=56a39d74&scoped=true&"
import script from "./xinXiBianJi.vue?vue&type=script&lang=js&"
export * from "./xinXiBianJi.vue?vue&type=script&lang=js&"
import style0 from "./xinXiBianJi.vue?vue&type=style&index=0&id=56a39d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a39d74",
  null
  
)

export default component.exports